import React from "react";
import { Outlet } from "react-router-dom";
import "./PlainLayout.scss";

export function PlainLayout() {
  return <Outlet />;
}
